@if (outdated()) {
    <ng-container *transloco="let t">
        @let message = t('REPORT.TEMPLATE.OUTDATED',
            {current: reportTemplate()?.templateVersion, new: reportTypeTemplateVersion()});
        <i class="fa fa-exclamation-triangle"
           [tooltip]="message"
           [attr.aria-label]="message">
        </i>
    </ng-container>
}

